export default __webpack_public_path__ + "images/CL.5e923c5.png";